/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component } from '@angular/core';
import { AuthStatusGuard } from './_guards';
import { AuthenticationService } from './_services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  showMenu: boolean;

  constructor(private status: AuthStatusGuard, private auth: AuthenticationService) {
    this.showMenu = false;
  }
  isLogged(): boolean {
    return this.status.isLogged();
  }

  _menu() {
      this.showMenu = !this.showMenu;
  }

  _setMenu(value) {
    this.showMenu = value;
  }

  isDistribuidora() {
    return this.auth.isDistrubuidora();
  }

  isMatriculado() {
    return this.auth.isMatriculado();
  }

}
